
export type OurValue = {
  bgColor: string
  title: string
  titleTextColor: string
  description: string
}

export const section3Data: OurValue[] = [
  {
    bgColor: 'bg-[#EBFBFF]',
    title: 'Get it done',
    titleTextColor: 'text-[#0C5F71]',
    description: 'Tenacious and willing to pioneer where others don’t.',
  },
  {
    bgColor: 'bg-[#EBF3FF]',
    title: 'Seek clarity',
    titleTextColor: 'text-[#205497]',
    description: 'Keep it simple so that legal professions are accessible to all.',
  },
  {
    bgColor: 'bg-[#EBEBFF]',
    title: 'Be data curious',
    titleTextColor: 'text-[#5858DF]',
    description: 'Stewards of market data and ask the questions that need to be asked.',
  },
]